import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import creditReducer from "../credit/credit.reducer";
import productReducer from "./product.reducer";
import { CreditState } from "../credit/credit-state.interface";
import { ProductState } from "./product-state.interface";

export interface RootState {
    credit: CreditState;
    product: ProductState;
}

const reducers = combineReducers({
    credit: creditReducer,
    product: productReducer
})

const preloadedState = (typeof window !== 'undefined') ? (window as any).__PRELOADED_STATE__ : {};
if((typeof window !== 'undefined')) delete (window as any).__PRELOADED_STATE__;


const store = configureStore({
    reducer: reducers,
    preloadedState
})

export type RootDispatch = typeof store.dispatch;

export default store;
export const useCreditDispatch = useDispatch<RootDispatch>
export const useProductDispatch = useDispatch<RootDispatch>
export const useCreditSelector: TypedUseSelectorHook<CreditState> = (selector) => useSelector((state: RootState) => selector(state.credit));
export const useProductSelector: TypedUseSelectorHook<ProductState> = (selector) => useSelector((state: RootState) => selector(state.product));